import AnalyzeService from '../../services/analyze';

// actions
export const UPLOAD_SURVEYS = 'UPLOAD_SURVEYS';
export const UPLOAD_SURVEYS_PROGRESS = 'UPLOAD_SURVEYS_PROGRESS';
export const UPLOAD_SURVEYS_MARK_AS_COMPLETED = 'UPLOAD_SURVEYS_MARK_AS_COMPLETED';

export function uploadFile(fileData, dispatch) {
  // file data arguments
  const { tenants, title, type, file, fileType, pesquisaDataInicio, pesquisaDataFinalizacao } = fileData;
  // upload service
  const service = new AnalyzeService();
  const dataPromise = service.uploadCSVFile(
    tenants,
    title,
    type,
    file,
    fileType,
    pesquisaDataInicio,
    pesquisaDataFinalizacao,
    (event) => {
      const { loaded, total } = event;
      const value = Math.round((loaded * 100) / total);
      const data = { progress: value };
      dispatch({ type: UPLOAD_SURVEYS_PROGRESS, payload: { data }});
    },
  );
  dispatch({ type: UPLOAD_SURVEYS, payload: dataPromise });
}

export function markAsCompleted(dispatch) {
  dispatch({ type: UPLOAD_SURVEYS_MARK_AS_COMPLETED, payload: null });
}
